import React from "react";
import {
  View,
  StyleSheet,
  TouchableOpacity,
  Image,
  Linking,
} from "react-native";
import { useSelector } from "react-redux";
import Text from "@components/AppText";
import analytics from "@services/analytics";
import Share from "react-native-share";
import handleFSPermission from "@utils/handleFSPermission";

import colors from "@constants/color";
import metrics, { isSmallScreen } from "@constants/metrics";

import GroupBuyIcon from "@assets/svg/GroupBuyIcon";
import WhatsappWhite from "@assets/svg/WhatsappWhite";
import { SHARE_GROUP_BUY } from "../../../constants/analyticsEvents";

const GroupBuyOfferCard = ({ gbOffer = {} }) => {
  const {
    cl_order_details_screen_title = "",
    cl_order_details_screen_message = "",
    homepage_card_color = "",
    homepage_text_color = "",
    group_buy_image = "",
    cl_share_link = "",
    cl_share_message = "",
    id = "",
    group_buy_banner = "",
  } = gbOffer || {};

  const {
    id: leader_id = "",
    name: leader_name = "",
    phone_number: leader_phone = "",
  } = useSelector(({ auth: { user } }) => user);

  const shareOnWhatsappWithImage = async () => {
    // analytics.trackEvent(SHARE_GROUP_BUY, {
    //   leader_id,
    //   leader_name,
    //   leader_phone,
    //   group_buy_id: id,
    //   cl_share_message,
    //   cl_share_link,
    //   fromScreen: "Orders",
    // });

    const message = `${cl_share_message}\n\n${cl_share_link}`;

    try {
      fetch(group_buy_banner)
        .then(async function (t) {
          const b = await t.blob();
          const reader = new FileReader();
          reader.readAsDataURL(b);
          reader.onloadend = async function () {
            const base64data = reader.result;
            const convert = base64data.replace(
              "data:application/octet-stream;",
              "data:image/png;",
            );
            const shareOptions = {
              title: "Share via",
              message,
              url: convert,
              social: Share.Social.WHATSAPP,
              whatsAppNumber: "",
              failOnCancel: false,
            };

            await Share.shareSingle(shareOptions);
          };
        })
        .catch((error) => console.log({ error }));
    } catch (e) {
      console.log(e);
    }
  };

  const shareOnWhatsapp = async () => {
    await handleFSPermission(() => shareOnWhatsappWithImage());
  };

  return (
    <View
      style={[styles.cardContainer, { backgroundColor: homepage_card_color }]}
    >
      <View style={styles.imageContainer}>
        <Image
          source={{ uri: group_buy_image }}
          style={{
            width: metrics.screenWidth / 8,
            height: metrics.screenHeight / 14,
          }}
        />
      </View>
      <View style={[styles.titleContainer, { width: "80%" }]}>
        <GroupBuyIcon />
        <Text
          fontType={isSmallScreen ? "content1" : "head3"}
          bold
          style={{
            color: homepage_text_color,
            lineHeight: 24,
            marginLeft: 10,
          }}
        >
          {cl_order_details_screen_title}
        </Text>
      </View>

      <View style={styles.messsageContainer}>
        <View style={{ flex: 7 }}>
          <Text
            fontType="content1"
            style={{ color: homepage_text_color, lineHeight: 20 }}
          >
            {cl_order_details_screen_message}
          </Text>
        </View>

        <View style={{ flex: 3 }}>
          <TouchableOpacity
            onPress={shareOnWhatsapp}
            style={[
              styles.button,
              {
                backgroundColor: colors.lima,
                borderColor: colors.lima,
                marginLeft: 10,
                width: "100%",
              },
            ]}
          >
            <WhatsappWhite />
            <Text
              fontType={isSmallScreen ? "content2" : "head3"}
              bold
              style={{ color: colors.white, marginLeft: 5 }}
            >
              {"शेयर करें"}
            </Text>
          </TouchableOpacity>
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  cardContainer: {
    flex: 1,
    width: "100%",
    height: "100%",
    alignSelf: "center",
    justifyContent: "center",
    alignItems: "center",
    marginRight: 10,
    padding: 10,
    borderRadius: 10,
  },
  titleContainer: {
    flexDirection: "row",
    paddingHorizontal: 10,
    justifyContent: "flex-start",
    alignSelf: "flex-start",
    alignItems: "center",
  },
  messsageContainer: {
    paddingTop: 10,
    paddingHorizontal: 10,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  imageContainer: {
    position: "absolute",
    right: 10,
    top: 10,
  },
  button: {
    paddingHorizontal: 10,
    paddingVertical: 5,
    borderRadius: metrics.screenWidth / 2,
    height: metrics.screenHeight / 18,
    width: metrics.screenWidth / 4.5,
    backgroundColor: colors.white,
    borderColor: colors.white,
    borderWidth: 1,
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
});

export default GroupBuyOfferCard;
